import React, { useState, useEffect } from 'react';
import { DropDownArrow2 } from '../../assets/icons';

export const InputWithSearch = ({ availableItem = [], selectedItem = [], setSelectedItem }) => {

  const [dataToShow, setDataToShow] = useState(availableItem);
  const [searchValue, setSearchValue] = useState("");

  const isNestedArray =
    Array.isArray(availableItem) && availableItem.length > 0 && Array.isArray(availableItem[0]);

  const getDisplayValue = (item) => {
    if (isNestedArray) {
      return Array.isArray(item) ? item[1] : item;
    }
    return item;
  };

  const getIdValue = (item) => {
    if (isNestedArray) {
      return Array.isArray(item) ? item[0] : item;
    }
    return item;
  };

  const findItemById = (id) => {
    const stringId = String(id);
    return availableItem.find((item) => String(getIdValue(item)) === stringId);
  };

  const getSelectedItemDisplay = (item) => {
    if (Array.isArray(item) && item.length > 1) {
      return item[1];
    }

    const id = Array.isArray(item) ? item[0] : item;
    const fullItem = findItemById(id);

    if (fullItem) {
      return getDisplayValue(fullItem);
    }

    return Array.isArray(item) ? item[0] : item;
  };

  const itemsEqual = (item1, item2) => {
    const id1 = getIdValue(item1);
    const id2 = getIdValue(item2);

    return String(id1) === String(id2);
  };

  const isItemSelected = (item) => {
    return selectedItem.some((selItem) => itemsEqual(selItem, item));
  };

  const handleListClick = (item) => {
    if (!isItemSelected(item)) {
      setSelectedItem((pre) => [...pre, item]);
    } else {
      setSelectedItem((pre) => pre.filter((selItem) => !itemsEqual(selItem, item)));
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(e.target.value);
    const filteredData = availableItem?.filter((item) => {
      const displayValue = getDisplayValue(item).toLowerCase();
      return displayValue.includes(value);
    });
    setDataToShow(filteredData);
  };

  const sortItems = (items) => {
    if (!Array.isArray(items)) return [];

    const selectedItems = items.filter((item) => isItemSelected(item));
    const unselectedItems = items.filter((item) => !isItemSelected(item));

    return [...selectedItems, ...unselectedItems];
  };

  useEffect(() => {
    // Clean selected items if they're not in availableItem
    const cleanedSelected = selectedItem.filter((selItem) =>
      availableItem.some((availItem) => itemsEqual(selItem, availItem))
    );

    // Only update if there's a change
    if (cleanedSelected.length !== selectedItem.length) {
      setSelectedItem(cleanedSelected);
    }

    // Update visible data as well
    setDataToShow(availableItem);
    setSearchValue("");
  }, [availableItem]);

  return (
    <div className="custom-dropdown-4 width-100 ">
      <div className="dropdown w-100">
        <button
          className="dropdown-toggle text-nowrap bg-white w-100 d-flex align-items-center justify-content-between"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          {selectedItem.length ? `${selectedItem.length} Item Selected` : 'Select Items'}
          <DropDownArrow2 />
        </button>
        <div className="dropdown-menu p-0 w-fit" aria-labelledby="dropdownMenuButton1">
          <div className="w-100 mt-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search.."
              value={searchValue}
              onChange={handleSearch}
            />
          </div>
          <ul className="list-data-area w-100 m-0 p-0">
            {Array.isArray(dataToShow) && dataToShow?.length ? (
              sortItems(dataToShow).map((item, index) => {
                const isSelected = isItemSelected(item);
                return (
                  <li
                    key={index}
                    onClick={() => handleListClick(item)}
                    className={isSelected ? 'disabled-item groupByList' : ''}>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="d-flex align-items-center justify-content-start"></span>
                      <span
                        className={`dropdown-item t-wrap d-flex align-items-center justify-content-start ${isSelected ? 'selected-item disabled groupByList' : ''
                          } `}>
                        {getSelectedItemDisplay(item)}
                        { }
                      </span>
                    </div>
                  </li>
                );
              })
            ) : (
              <li>
                <div className="dropdown-item t-wrap d-flex align-items-center justify-content-start">
                  {'No records found'}
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
